module.exports = __webpack_public_path__ + "static/media/MC4@2x.ebf05798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/MC/MC4@2x.png
// module id = 697
// module chunks = 0